/**
 * 회전 슬라이더 컨트롤러.
 *
 * 반시계 방향 회전 시 구간 점프, 시계 방향 회전 시 끝 부분에서 회전 중단 이슈 여전히 발생 -> 대응 필요
 */

const normalizeAngle = (deg) => {
  const num = Number(deg);
  if (!Number.isFinite(num)) return 0;
  let mod = ((num % 360) + 360) % 360;
  if (mod >= 180) mod -= 360;
  return mod;
};

export const setRotationController = function ($) {
  $.Viewer.prototype.slider = function (options) {
    if (!this.sliderInstance) {
      options = options || {};
      options.viewer = this;
      this.sliderInstance = new $.Slider(options);
    } else {
      this.sliderInstance.refresh(options);
    }
  };

  $.Slider = function (options = {}) {
    this.viewer = options.viewer;
    this._updatingFromSlider = false;
    this.wrapperDiv = document.createElement('div');
    this.wrapperDiv.style.position = 'absolute';
    this.wrapperDiv.style.top = '5px';
    this.wrapperDiv.style.right = '9.3em';
    this.wrapperDiv.style.padding = '2px 5px 8px 5px';
    this.wrapperDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    this.wrapperDiv.style.borderRadius = '4px';
    this.wrapperDiv.style.border = '1px solid rgba(255, 255, 255, 0.3)';
    this.wrapperDiv.style.display = 'flex';
    this.wrapperDiv.style.flexDirection = 'column';
    this.wrapperDiv.style.gap = '6px';
    this.wrapperDiv.style.alignItems = 'center';

    this.labelRow = document.createElement('div');
    this.labelRow.style.display = 'flex';
    this.labelRow.style.alignItems = 'center';
    this.labelRow.style.justifyContent = 'space-between';
    this.labelRow.style.width = '100%';

    this.sliderLabel = document.createElement('div');
    this.sliderLabel.innerHTML = 'Rotation';
    this.sliderLabel.style.fontSize = '0.6rem';
    this.sliderLabel.style.color = 'white';
    this.sliderLabel.style.margin = '0';

    this.resetBtn = document.createElement('button');
    this.resetBtn.innerHTML = '↺';
    this.resetBtn.style.background = 'none';
    this.resetBtn.style.border = 'none';
    this.resetBtn.style.color = '#fff';
    this.resetBtn.style.fontSize = '0.7rem';
    this.resetBtn.style.cursor = 'pointer';
    this.resetBtn.style.padding = '0 2px';
    this.resetBtn.style.lineHeight = '1';

    this.labelRow.appendChild(this.sliderLabel);
    this.labelRow.appendChild(this.resetBtn);

    this.inputElem = document.createElement('input');
    this.inputElem.className = 'elem rotation-slider';
    this.inputElem.type = 'range';
    this.inputElem.value = '0';
    this.inputElem.min = '-180';
    this.inputElem.max = '180';
    this.inputElem.style.cursor = 'pointer';
    this.inputElem.style.margin = '0';
    this.inputElem.style.width = '100px';

    const updateTrack = (input) => {
      const min = Number(input.min);
      const max = Number(input.max);
      const pct = ((Number(input.value) - min) / (max - min)) * 100;
      input.style.background =
        `linear-gradient(to right, rgb(174, 203, 255) ${pct}%, rgba(255, 255, 255, 0.4) ${pct}%)`;
    };
    updateTrack(this.inputElem);

    // 슬라이더 → 뷰어
    this.inputElem.oninput = (event) => {
      const value = Number(event.target.value);
      this._updatingFromSlider = true;
      try {
        this.viewer.viewport.setRotation(value);
      } finally {
        this._updatingFromSlider = false;
      }
      updateTrack(event.target);
    };

    // 뷰어 → 슬라이더
    this._rotateHandler = (e) => {
      if (this._updatingFromSlider) return;

      let raw = e && e.degrees;
      if (raw === undefined || raw === null || !Number.isFinite(Number(raw))) {
        raw = this.viewer.viewport.getRotation?.() ?? 0;
      }

      const normalized = normalizeAngle(raw);
      const current = Number(this.inputElem.value);
      if (Math.abs(normalized - current) < 0.01) return;

      this.inputElem.value = String(normalized);
      updateTrack(this.inputElem);
    };
    this.viewer.addHandler('rotate', this._rotateHandler);

    this.resetBtn.onclick = () => {
      this.inputElem.value = '0';
      this._updatingFromSlider = true;
      try {
        this.viewer.viewport.setRotation(0);
      } finally {
        this._updatingFromSlider = false;
      }
      updateTrack(this.inputElem);
    };

    this.wrapperDiv.appendChild(this.labelRow);
    this.wrapperDiv.appendChild(this.inputElem);
    this.viewer.container.appendChild(this.wrapperDiv);

    const initialRotation = this.viewer.viewport.getRotation?.() ?? 0;
    this.inputElem.value = String(normalizeAngle(initialRotation));
    updateTrack(this.inputElem);
  };

  $.Slider.prototype.refresh = function (options) {
  };

  $.Slider.prototype.setVisible = function (visible) {
    this.wrapperDiv.style.display = visible ? 'flex' : 'none';
  };

  $.Slider.prototype.destroy = function () {
    if (this._rotateHandler && this.viewer) {
      try {
        this.viewer.removeHandler('rotate', this._rotateHandler);
      } catch (e) {
        /* noop */
      }
      this._rotateHandler = null;
    }
    if (this.wrapperDiv && this.wrapperDiv.parentNode) {
      this.wrapperDiv.parentNode.removeChild(this.wrapperDiv);
    }
  };
};